// extracted by mini-css-extract-plugin
export default {"common-style":"btn_common-style__8BwRd","cancel-btn":"btn_cancel-btn__pEi8R","submit-btn":"btn_submit-btn__vT5S2","wrap-submit-cancel":"btn_wrap-submit-cancel__j49zQ"};